import HeroSection from './HeroSection';
import SponsorPane from './SponsorPane';
import ChallengeSection from './ChallengeSection';
import TeamSection from './TeamSection';
import VideoSection from './VideoSection';
import InstagramSection from './InstagramSection';
import Footer from './Footer';

const Home = () => {
  return (
    <>
      <HeroSection />
      <SponsorPane />
      <ChallengeSection />
      <VideoSection />
      <TeamSection />
      <InstagramSection />
      <Footer />
    </>
  );
};

export default Home;

